<template>
    <b-row>
        <b-col sm class="panel-meter-info-name">{{ formattedName }}</b-col>
        <b-col sm class="panel-meter-info-value">
            <span class="value-value">{{ formattedValue }}</span>
            <span class="value-metric"> {{ meterMetric }}</span>
        </b-col>
        <b-col cols="12" class="panel-meter-info-date">
            <span class="date-actualized">{{ $t('dashboard.actualized') }}:&nbsp;</span>
            <span class="date-metric">{{ meterDate }}</span>
        </b-col>
    </b-row>
</template>

<script>
    /**
     * Shows listed sensor's information.
     * Single item.
     */

    export default {
        name: "RightPanelContainerSensor",
        props: {
            meterName: {
                type: String,
                default: ''
            },
            meterValue: [Number, String],
            meterMetric: String,
            meterDate: String,
            index: {
                type: [Number, String],
                required: false,
                default: 0
            }
        },
        computed: {
            /**
             * Check if translation exists.
             * If so, use it along with any index (if supplied)
             * @returns {string}
             */
            formattedName() {
                let theName = '';
                const theIndex = this.index ? ` ${this.index}` : '';

                if (this.$i18n.te(`sensors.${this.meterName}`)) {
                    theName = this.$i18n.t(`sensors.${this.meterName}`);
                } else {
                    // force convert to string
                    theName = this.meterName + '';
                }

                return (theName + theIndex);
            },
            formattedValue() {
                return this.meterValue;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/variables";

    .row {
        margin-bottom: 8px;
    }
    /* ******** panel info listing - per item */
    .panel-meter-info-name {
        text-align: left;
        font: 300 14px/14px Nunito, sans-serif;
        letter-spacing: 0;
        color: #000000;
        opacity: 1;
        padding-left: 25px;
        margin-bottom: 5px;
        /* if meter is having a problem, color red */
        &.problem {
            color: #F53D35;
            :after {
                content: '\f12a';
                font-family: FontAwesome,sans-serif;
                font-weight: normal;
                font-style: normal;
                margin: 0px 0px 0px 10px;
                text-decoration: none;
                color: $whiteColor;
                background-color: #FF0000;
                border-radius: 50%;
                width: 16px;
                height: 16px;
                padding: 1px;
                display: inline-block;
                text-align: center;
            }
        }
    }
    .panel-meter-info-value {
        text-align: right;
        font: 300 14px/19px Nunito, sans-serif;
        letter-spacing: 0px;
        color: #000000;
        opacity: 1;
    }
    .panel-meter-info-date {
        text-align: left;
        font: 300 12px/14px Nunito, sans-serif;
        letter-spacing: 0px;
        color: #909090;
        opacity: 1;
        padding-left: 30px;
    }
</style>